export default __webpack_public_path__ + "6d046ccac30d85de4a18e9613447a624.png";